// Authentication utility functions

// Check if user is logged in (any type)
export const isLoggedIn = () => {
  return isUserLoggedIn() || isAdminLoggedIn();
};

// Check if regular user is logged in
export const isUserLoggedIn = () => {
  const userToken = localStorage.getItem("accessToken") || localStorage.getItem("token");
  return !!userToken;
};

// Check if admin is logged in
export const isAdminLoggedIn = () => {
  const adminToken = localStorage.getItem("admin_token");
  return !!adminToken;
};

// Decode JWT token (without verification - for client-side use only)
export const decodeToken = (token) => {
  try {
    if (!token) return null;
    
    // Split the token and get the payload part
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

// Get user role from admin token
export const getAdminRole = () => {
  const adminToken = localStorage.getItem("admin_token");
  if (!adminToken) return null;
  
  const decoded = decodeToken(adminToken);
  return decoded?.role || null;
};

// Check if current admin user is a super admin
export const isSuperAdmin = () => {
  const role = getAdminRole();
  return role === 'admin';
};

// Check if current admin user is a sub-admin
export const isSubAdmin = () => {
  const role = getAdminRole();
  return role === 'subadmin';
};

// Get the type of user currently logged in
export const getUserType = () => {
  if (isAdminLoggedIn()) return 'admin';
  if (isUserLoggedIn()) return 'user';
  return null;
};

// Get the appropriate token for API calls
export const getAuthToken = () => {
  if (isAdminLoggedIn()) {
    return localStorage.getItem("admin_token");
  } else if (isUserLoggedIn()) {
    return localStorage.getItem("accessToken") || localStorage.getItem("token");
  }
  return null;
};

// Clear all authentication data
export const clearAuthData = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("token");
  localStorage.removeItem("admin_token");
  localStorage.removeItem("userInfo");
  localStorage.removeItem("userData");
  sessionStorage.clear();
};

// Get the appropriate dashboard route for the user type
export const getDashboardRoute = () => {
  const userType = getUserType();
  if (userType === 'admin') return '/AdminDashboard';
  if (userType === 'user') return '/dashboard';
  return '/';
};

// Check if user can access a specific route
export const canAccessRoute = (requiredUserType = null) => {
  const userType = getUserType();
  
  if (!userType) return false;
  
  if (requiredUserType && userType !== requiredUserType) {
    return false;
  }
  
  return true;
}; 